import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useContext } from 'react';
import config from 'config';
import { useDomain } from '@techstyle/redux-core';
import useIntl from './useIntl';
export var CurrencyFormatContext = /*#__PURE__*/React.createContext();
export default function useCurrency() {
  var _useDomain = useDomain(),
      tld = _useDomain.tld;

  var _useIntl = useIntl(),
      siteLocale = _useIntl.locale; // NOTE: CurrencyFormatProvider itself uses `useCurrency`, so make sure to
  // support no context value.


  var currencyFormat = useContext(CurrencyFormatContext);
  var currencies = config.get('public.intl.currencies');
  var currency = currencies[tld];
  var formatCurrency = useCallback(function (amount) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var currencyLocaleFromContext = currencyFormat.locale,
        prefix = currencyFormat.prefix,
        prefixStringFromContext = currencyFormat.prefixString,
        suffix = currencyFormat.suffix,
        suffixStringFromContext = currencyFormat.suffixString,
        trimZerosFromContext = currencyFormat.trimZeros,
        contextFormatOptions = _objectWithoutProperties(currencyFormat, ["locale", "prefix", "prefixString", "suffix", "suffixString", "trimZeros"]);

    var _options$locale = options.locale,
        locale = _options$locale === void 0 ? currencyLocaleFromContext || siteLocale : _options$locale,
        _options$prefixString = options.prefixString,
        prefixString = _options$prefixString === void 0 ? prefixStringFromContext : _options$prefixString,
        _options$suffixString = options.suffixString,
        suffixString = _options$suffixString === void 0 ? suffixStringFromContext : _options$suffixString,
        _options$trimZeros = options.trimZeros,
        trimZeros = _options$trimZeros === void 0 ? trimZerosFromContext : _options$trimZeros,
        formatOptions = _objectWithoutProperties(options, ["locale", "prefixString", "suffixString", "trimZeros"]);

    var finalOptions = _objectSpread(_objectSpread({}, contextFormatOptions), formatOptions);

    if (trimZeros && amount % 1 === 0) {
      finalOptions.minimumFractionDigits = 0;
    } // We can't use `narrowSymbol` for `currencyDisplay` because it's not
    // supported in Node and some browsers like Safari. So our next best
    // option is to change the `locale` used for currencies so that the
    // output when `symbol` is used is correct. But react-intl's
    // `formatNumber` doesn't allow overriding the locale, so we need to
    // use the `Intl.NumberFormat` API directly.


    var formatter = new Intl.NumberFormat(locale, _objectSpread({
      style: 'currency',
      currency: currency
    }, finalOptions));
    var currencyString = formatter.format(amount);
    return "".concat(prefixString).concat(currencyString).concat(suffixString);
  }, [currency, currencyFormat, siteLocale]);
  return _objectSpread({
    currency: currency,
    formatCurrency: formatCurrency
  }, currencyFormat);
}